import { defineComponent as _defineComponent } from 'vue'
import { watch, ref, provide, computed } from "vue"
import { Step } from "@/modules/Users/Invitation/constants"
import InvitationLayout from "@/modules/Users/Invitation/shared/InvitationLayout.vue"
import CheckStep from "@/modules/Users/Invitation/shared/CheckStep.vue"
import CompanyInfoForm from "@/modules/Users/Invitation/CompanyInfoForm/CompanyInfoForm.vue"
import ProjectDetailsForm from "@/modules/Users/Invitation/Project/ProjectDetailsForm/ProjectDetailsForm.vue"
import ClientPersonalInfoForm from "@/modules/Users/Invitation/ClientPersonalInfoForm/ClientPersonalInfoForm.vue"
import FinalStep from "@/modules/Users/Invitation/shared/FinalStep.vue"
import {
  CreateClientWithUserMutation,
  CreateClientWithUserMutationMutationVariables,
  CreateClientWithUserMutationMutation,
  MissionRequestInput,
  ScopeServiceFragmentFragment,
} from "@/gql"

import { useMutation } from "@/hooks/useMutation"
import { useNotification } from "@/hooks/useNotification"
import { OnboardingFormValues } from "@/modules/Users/Invitation/shared/types"


export default /*#__PURE__*/_defineComponent({
  __name: 'PeraltaClientSignUpFlow',
  setup(__props) {

const step = ref(Step.ProjectDetails)
const stages = [Step.ProjectDetails, Step.CompanyInfo, Step.PersonalInfo, Step.Final]
const completedSteps = ref<string[]>([])

watch(step, () => (completedSteps.value = [...completedSteps.value, step.value]), {
  immediate: true,
})

const gotoNext = () => {
  const index = stages.findIndex((s) => s === step.value)
  if (index < stages.length - 1) {
    step.value = stages[index + 1]
  }
}

const gotoPrev = () => {
  const index = stages.findIndex((s) => s === step.value)
  if (index > 0) {
    step.value = stages[index - 1]
  }
}

const gotoFinal = () => {
  step.value = Step.Final
}

const isSubmitting = ref(false)

const form = ref<OnboardingFormValues>({
  newUserInput: {
    password: "",
    firstName: "",
    lastName: "",
    email: "",
    clientAdminPosition: "",
  },
  newClientInput: {
    name: "",
    website: "",
    countryId: "",
    address: "",
    description: "",
    industry: "",
    companySizeRange: null,
    ownershipStructure: null,
  },
  missionRequestInput: {
    projectBrief: "",
    termsOfReferenceAttributes: null,
    scopeServiceId: "",
  },
  invitationId: undefined,
  token: undefined,
  promoCodeInput: {
    code: "",
    partnerSource: null,
  },
})

provide("onboardingForm", form)

const activeService = ref<ScopeServiceFragmentFragment | null>(null)

const updateProjectInput = (
  value: MissionRequestInput & { service: ScopeServiceFragmentFragment; email: string }
) => {
  form.value = {
    ...form.value,
    missionRequestInput: {
      projectBrief: value.projectBrief,
      projectLocationType: value.projectLocationType,
      scopeServiceId: value.scopeServiceId,
      termsOfReferenceAttributes: value.termsOfReferenceAttributes || undefined,
    },
  }

  activeService.value = value.service
  form.value.newUserInput.email = value.email
}

const { mutate } = useMutation()
const { addSuccess } = useNotification()

const onSubmitted = async () => {
  isSubmitting.value = true
  const result = await mutate<
    CreateClientWithUserMutationMutation,
    CreateClientWithUserMutationMutationVariables
  >({
    mutation: CreateClientWithUserMutation,
    variables: {
      ...form.value,
      missionRequestInput: form.value.missionRequestInput?.scopeServiceId
        ? form.value.missionRequestInput
        : undefined,
    },
  })
  if (result?.data?.createClientWithUser.clientPayload) {
    addSuccess("Client created successfully!")
    gotoFinal()
  }
  isSubmitting.value = false
}

const userEmailAndPassword = computed(() => ({
  email: form.value.newUserInput.email as string,
  password: form.value.newUserInput.password as string,
}))

const onPartnerCodeChange = (input: Record<string, any>) => {
  form.value.promoCodeInput = {
    ...form.value.promoCodeInput,
    code: input.code,
    partnerSource: input.partnerSource,
  }
}

return { __sfc: true,step, stages, completedSteps, gotoNext, gotoPrev, gotoFinal, isSubmitting, form, activeService, updateProjectInput, mutate, addSuccess, onSubmitted, userEmailAndPassword, onPartnerCodeChange, Step, InvitationLayout, CheckStep, CompanyInfoForm, ProjectDetailsForm, ClientPersonalInfoForm, FinalStep }
}

})